import { Tag } from '@playq/octopus-common';

import { findTagKeyAndValue } from './findTagKeyAndValue';

export const createTag = (text: string): Tag => {
  const { key, value } = findTagKeyAndValue(text);
  return new Tag({ key, value: value === '' ? undefined : value });
};
